module.exports = __webpack_public_path__ + "static/images/3c6f17952b3ffd942d24f4566168c2c3.png";